module.exports = __webpack_public_path__ + "static/media/mark_in_active_white.55298264.svg";